import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Account } from "../../hooks/apis/accounts.api";
import { Carrier } from "../../hooks/apis/carriers.api";

export interface adminState {
    accounts: Account[];
    selectedView: string
    carriers: Carrier[]
    selectedAccount: string
}


export const initialState: adminState = {
    accounts: [],
    selectedView: "info",
    carriers: [],
    selectedAccount: "",
}

export const admin = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAccounts: (state, action: PayloadAction<Account[]>) => {
            state.accounts = action.payload
        }
        ,
        setSelectedView: (state, action: PayloadAction<string>) => {
            state.selectedView = action.payload
        },
        setCarriers: (state, action: PayloadAction<Carrier[]>) => {
            state.carriers = action.payload
        },
        setSelectedAccount: (state, action: PayloadAction<string>) => {
            state.selectedAccount = action.payload
        },


    }
})

export const { setAccounts, setSelectedView, setCarriers, setSelectedAccount } = admin.actions

export default admin.reducer